import logo_normal from '../../assets/images/logo_v2.png'
import new_logo_black_big from '../../assets/images/new_logo_black_big.png'
import new_logo_white_big from '../../assets/images/new_logo_white_big.png'

interface Props { 
    variant: 'normal' | 'black' | 'white' | 'small' | 'small_white';
}

export const Logo: React.FC<Props> = ({variant}) => {
    return (
        <div>
            {variant === 'normal' && <img src={new_logo_black_big} alt="Logo normal" width="150" />   }
            {variant === 'white' && <img src={logo_normal} alt="Logo white" width="200" />   }
            {variant === 'black' && <img src={new_logo_black_big} alt="Logo black" width="200" />   }
            {variant === 'small' && <img src={new_logo_black_big} alt="Logo black" width="60" />   }
            {variant === 'small_white' && <img src={new_logo_white_big} alt="Logo black" width="40" />   }
        </div>
    );
}